import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { CircularProgress, FormControl, FormHelperText, Grid, MenuItem, Select } from '@mui/material';
import { Form, Formik } from 'formik';
import { FMTextField } from '../Elements/input';
import useAuth from "../../context/AuthProvider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Swal from 'sweetalert2';
import { StateLoginsModel, StateLoginsModel_VS } from '../../models/StateLoginsModel';
import { apiClient } from '../../helper/api';

interface Iprops {
    item: StateLoginsModel;
    handleClose: () => void;
    Open: boolean;
    initValues: StateLoginsModel;
    states: { stateId: string, stateName: string }[];
    partners: { partnersId: number, customerName: string }[];
}

export const AddEditStateLogins: React.FC<Iprops> = ({ 
    handleClose, 
    Open, 
    item,
    initValues, 
    states, 
    partners 
}) => {
    const initialValues: StateLoginsModel = initValues ? item : initValues;
    const { user } = useAuth();
    const token = user?.token;

    const handleFormSubmit = async (data: any, { setSubmitting }: any) => {
        try {
            const res = await apiClient('/StateLogins/SaveOrUpdate', {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }),
                body: JSON.stringify(data)
            });
            if (res?.status === true) {
                Swal.fire({
                    title: 'Success',
                    text: res.message || 'Data Successfully saved',
                    icon: "success",
                    confirmButtonText: "OK",
                });
                handleClose();
            }else {
                Swal.fire({
                    title: "Error!",
                    text: res?.message || "Something went wrong while saving.",
                    icon: "warning",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            console.error('Error saving state login:', error);
            Swal.fire({
                title: "Error!",
                text: "A network or server error occurred.",
                icon: "error",
                confirmButtonText: "OK",
            });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Dialog open={Open} onClose={handleClose}>
            <DialogTitle className='card-title'>State Login</DialogTitle>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validateOnChange={true}
                validationSchema={StateLoginsModel_VS}
                onSubmit={handleFormSubmit}
            >
                {({ values, isSubmitting, setFieldValue, errors }) => (
                    <Form className='main-form'>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <FormHelperText className='formtexthelper-heading'>
                                            Licensee
                                        </FormHelperText>
                                        <FMTextField 
                                            name="licensee" 
                                            autoComplete='off' 
                                            margin="dense" 
                                            label={null} 
                                            type="text" 
                                            fullWidth 
                                            variant="outlined" 
                                            sx={{ m: 2 }} 
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl error={!!errors.statename} fullWidth>
                                        <FormHelperText className='formtexthelper-heading'>
                                            State
                                        </FormHelperText>
                                        <Select
                                            value={values.statename}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                const sel = states.find(v => v.stateName === val);
                                                setFieldValue("statename", val);
                                                setFieldValue("stateId", sel?.stateId);
                                            }}
                                            name="statename"
                                            className="border-round custom-menu-item"
                                            IconComponent={ExpandMoreIcon}
                                            displayEmpty
                                        >
                                            <MenuItem key={0} value={''}>
                                                Select State
                                            </MenuItem>
                                            {states.map((state, key) => (
                                                <MenuItem key={key} value={state.stateName}>
                                                    {state.stateName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText>{errors.statename}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <FormHelperText className='formtexthelper-heading'>
                                            Website
                                        </FormHelperText>
                                        <FMTextField 
                                            name="website" 
                                            autoComplete='off' 
                                            margin="dense" 
                                            label={null} 
                                            type="text" 
                                            fullWidth 
                                            variant="outlined" 
                                            sx={{ m: 2 }} 
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <FormHelperText className='formtexthelper-heading'>
                                            Username
                                        </FormHelperText>
                                        <FMTextField 
                                            name="username" 
                                            autoComplete='off' 
                                            margin="dense" 
                                            label={null} 
                                            type="text" 
                                            fullWidth 
                                            variant="outlined" 
                                            sx={{ m: 2 }} 
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <FormHelperText className='formtexthelper-heading'>
                                            Password1
                                        </FormHelperText>
                                        <FMTextField 
                                            name="password1" 
                                            autoComplete='off' 
                                            margin="dense" 
                                            label={null} 
                                            type="text" 
                                            fullWidth 
                                            variant="outlined" 
                                            sx={{ m: 2 }} 
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <FormHelperText className='formtexthelper-heading'>
                                            Password2
                                        </FormHelperText>
                                        <FMTextField 
                                            name="password2" 
                                            autoComplete='off' 
                                            margin="dense" 
                                            label={null} 
                                            type="text" 
                                            fullWidth 
                                            variant="outlined" 
                                            sx={{ m: 2 }} 
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <FormHelperText className='formtexthelper-heading'>
                                            Notes
                                        </FormHelperText>
                                        <FMTextField 
                                            name="notes" 
                                            autoComplete='off' 
                                            margin="dense" 
                                            label={null} 
                                            type="text" 
                                            fullWidth 
                                            variant="outlined" 
                                            sx={{ m: 2 }} 
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl error={!!errors.client} fullWidth>
                                        <FormHelperText className='formtexthelper-heading'>
                                            Client
                                        </FormHelperText>
                                        <Select
                                            value={values.client}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                const sel = partners.find(v => v.customerName === val);
                                                setFieldValue("client", val);
                                                setFieldValue("partnersId", sel?.partnersId);
                                            }}
                                            name="client"
                                            className="border-round custom-menu-item"
                                            IconComponent={ExpandMoreIcon}
                                            displayEmpty
                                        >
                                            <MenuItem key={0} value={''}>
                                                Select Client
                                            </MenuItem>
                                            {partners.map((client, key) => (
                                                <MenuItem key={key} value={client.customerName}>
                                                    {client.customerName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText>{errors.statename}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth>
                                            <FormHelperText className='formtexthelper-heading'>
                                                Account ID
                                            </FormHelperText>
                                            <FMTextField 
                                                name="accountID" 
                                                autoComplete='off' 
                                                margin="dense" 
                                                label={null} 
                                                type="text" 
                                                fullWidth 
                                                variant="outlined" 
                                                sx={{ m: 2 }} 
                                            />
                                        </FormControl>
                                    </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <button 
                                className="btn-2 btn d-flex btn-primary search-btn" 
                                type='button' 
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button 
                                className="btn btn-primary active-btn-blue search-btn" 
                                type='submit' 
                                disabled={isSubmitting}
                            >
                                Submit
                            </button>
                            {isSubmitting && <CircularProgress style={{ margin: 2 }} />}
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};
